const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, notFound } from "@tanstack/react-router";
import { changeLanguage } from "@/lib/i18n";
import { isSupportedLocale } from "@/lib/supported-locales";
export const Route = createFileRoute("/{-$locale}")({
  beforeLoad: async ({
    params
  }) => {
    if (params.locale && !isSupportedLocale(params.locale)) {
      throw notFound();
    }
    if (params.locale) {
      await changeLanguage(params.locale);
    }
    return {
      locale: params.locale
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});